// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1J3Gn","bigColWidth":"Table_bigColWidth__2_DJz","biggerColWidth":"Table_biggerColWidth__tiXL6","row":"Table_row__2zjvv","col":"Table_col__UvQFW"};